exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-menu-no-padding {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/cmodules/cmodules-details/cmodules-datepicker/cmodules-datepicker.component.css
// module id = ../../../../../src/app/modules/cmodules/cmodules-details/cmodules-datepicker/cmodules-datepicker.component.css
// module chunks = main